import type { GalleryState } from '@/models/gallery.model'

/**
 * Thrown by `fetchGallery` when the server responds with an error status.
 *
 * The `reason` field carries a typed {@link GalleryState} value so callers
 * can branch on the error condition without string-matching the message.
 */
export class GalleryError extends Error {
  /** Typed reason that maps directly to {@link GalleryState}. */
  readonly reason: GalleryState

  constructor(reason: GalleryState, message?: string) {
    super(message ?? `Gallery error: ${reason}`)
    this.name = 'GalleryError'
    this.reason = reason
  }
}
